<template>
<el-dialog :close-on-click-modal="false" append-to-body :visible.sync="show" :title="title" :width="width">
  <template slot="title">
    <span class="dialog-title">
      <i class="icon el-icon-success" v-if="icon && icon === 'success'"></i>{{ title }}</span>
    <span class="sub-title" v-if="subTitle">{{ subTitle }}</span>
  </template>
  <slot></slot>
  <div slot="footer" :class="['dialog-footer', showCancel ? 'showCancel' : '']" v-if="showFooter">
    <el-button v-if="showCancel" :class="['default-btn', sourceType]" @click="cancel">{{ cancelText }}</el-button>
    <el-button type="primary" :class="['primary-btn', sourceType]" @click="confirm">{{ confirmText }}</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  props: {
    showFooter: {
      type: Boolean,
      default: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    title: {
      type: String,
      default: '标题'
    },
    width: {
      type: String,
      default: '640px'
    },
    value: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: ''
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog {
  border-radius: 4px;
}
::v-deep .el-dialog__header {
  border-radius: 4px 4px 0 0;
  background-color: #fff;
}
::v-deep .el-dialog__footer {
  border-top: none;
}
.dialog-title {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: bold;
}
.dialog-title .icon {
  margin-right: 4px;
}
.icon.el-icon-success {
  color: rgba(92, 215, 90, 1);
}
.sub-title {
  font-size: 14px;
  color: rgba(88, 88, 88, 1);
  font-weight: normal;
  padding-left: 12px;
}
.default-btn {
  width: 50%;
  border-radius: 12px;
  padding: 12px 10px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(246, 87, 170, 1);
  border-color: rgba(246, 87, 170, 1);
}
.default-btn.sup {
  color: #9765FC;
  border-color: #9765FC; 
}
.primary-btn {
  width: 50%;
  border-radius: 12px;
  padding: 12px 10px;
  font-size: 18px;
  font-weight: bold;
  background-color: rgba(246, 87, 170, 1);
  border-color: rgba(246, 87, 170, 1);
}
.primary-btn.sup {
  background-color: #9765FC;
  border-color: #9765FC;
}
.showCancel {
  padding: 0 10%;
  display: flex;
}
.showCancel .default-btn,
.showCancel .primary-btn {
  flex: 1;
}
</style>